import { TWhiteLabelStore } from '../white-label.model';

export function setItemBorder(themeWrapper: HTMLBodyElement, whiteLabel: TWhiteLabelStore): void {
  themeWrapper.style.setProperty('--itemBorder', whiteLabel.data.itemBorder);
}
